<div class="flex flex-col">
    <h6  class="text-xxs text-zen-blueGrey uppercase font-medium px-8 leading-7">{{title}}</h6>
    <div class="flex flex-col pb-5">
        <ng-content></ng-content>
    </div>
</div>
